import React, { useRef, useState } from "react";
import "./styles/page.css";

import {
  Box,
  ThemeProvider,
  createTheme,
  Grid,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import MonthlyMagazine from "./pages/magazine";
import { useReactToPrint } from "react-to-print";
import AddressBook from "./pages/address-book";
import MAGAZINE_DATASET from "./data/magazine_export.json";
import ADDRESS_DATASET from "./data/address_book_export.json";
import DocumentGenerator from "./pages/document-generator";

const theme = createTheme({
  typography: {
    fontFamily: ["Noto Sans Sinhala Variable", "sans-serif"].join(","),
  },
});

const GENERATION_CRITERIA = Object.freeze({
  Magazine: "Magazine",
  AddressBook: "AddressBook",
});

const RADIO_META = [
  { label: "Monthly Magazine", value: GENERATION_CRITERIA.Magazine },
  { label: "Address Book", value: GENERATION_CRITERIA.AddressBook },
];

const App = () => {
  const [magazineDataset, setMagazineDataset] = useState({});
  const [addressDataset, setAddressDataset] = useState([]);
  const [currentCriteria, setCurrentCriteria] = useState(
    GENERATION_CRITERIA.Magazine
  );
  const [isPrintable, setIsPrintable] = useState(false);

  const printAreaRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printAreaRef.current,
  });

  const handleGenerate = () => {
    switch (currentCriteria) {
      case GENERATION_CRITERIA.AddressBook:
        setAddressDataset(ADDRESS_DATASET);
        break;
      default:
        setMagazineDataset(MAGAZINE_DATASET.offline_data);
        break;
    }
    setIsPrintable(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        bgcolor="#f2f3f4"
        padding={2}
        minHeight="100vh"
      >
        <DocumentGenerator />
      </Box>
    </ThemeProvider>
  );
};

export default App;
